export default __webpack_public_path__ + "static/media/chevron-down.84a0f777.svg";